// extracted by mini-css-extract-plugin
export default {"fkBlue":"#0063be","fkGrey":"#efefef","fkDarkGrey":"#636363","fkWhite":"#fff","container":"LoadingSpinner_container__ukDG0","box":"LoadingSpinner_box__DpYOU"};